import Swal from "sweetalert2";

function get_donation_checkout_error_message(response) {
  return response?.message || "Unable to start donation payment.";
}

function show_donation_checkout_success_toast() {
  Swal.fire({
    title: "Success",
    icon: "success",
    text: "Redirecting to PayFast in a few seconds don't close this page",
    showConfirmButton: false,
    timer: 3000,
    position: "bottom-end",
    toast: true,
  });
}

function submit_donation_checkout_form(form) {
  $("#donation_checkout_modal").modal("hide");
  show_donation_checkout_success_toast();
  form.submit();
}

function build_donation_checkout_request(instance) {
  return {
    url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/create_campaign_donation/`,
    method: "POST",
    data: JSON.stringify(instance.get_donation_request_payload()),
    headers: {
      ...instance.get_request_headers(),
      "Content-Type": "application/json",
    },
    success: (response) => instance.handle_donation_checkout_success(response),
    error: (error) => instance.handle_donation_checkout_error(error),
    complete: () => {
      instance.is_processing_donation = false;
    },
  };
}

export const donation_checkout_methods = {
  get_donation_checkout_response_data(response) {
    return response?.data_array || response?.data?.data_array || null;
  },
  is_donation_checkout_success(response) {
    return Boolean(
      response?.success === true ||
      String(response?.status || "").toLowerCase() === "success"
    );
  },
  show_donation_checkout_error(message) {
    Swal.fire({
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 2500,
      position: "bottom-end",
      toast: true,
    });
  },
  handle_donation_checkout_success(response) {
    const data_array = this.get_donation_checkout_response_data(response);

    if (!this.is_donation_checkout_success(response) || !data_array) {
      this.show_donation_checkout_error(get_donation_checkout_error_message(response));
      return;
    }

    const form = this.append_payfast_form_inputs(data_array);
    submit_donation_checkout_form(form);
  },
  handle_donation_checkout_error(error) {
    this.show_donation_checkout_error(
      error?.responseJSON?.message || "Payment failed. Please try again later."
    );
  },
  start_donation_checkout() {
    if (!this.validate_donation_checkout_amount()) {
      return;
    }

    this.is_processing_donation = true;
    $.ajax(build_donation_checkout_request(this));
  },
};
